import setupDeprecationWorkflow from 'ember-cli-deprecation-workflow';

const deprecationsToSilence: string[] = [
  'deprecate-import--is-destroyed-from-ember',
  'deprecate-import--is-destroying-from-ember',
  'deprecate-import--register-destructor-from-ember',
  'deprecate-import--set-classic-decorator-from-ember',
  'deprecate-import-change-properties-from-ember',
  'deprecate-import-destroy-from-ember',
  'deprecate-import-libraries-from-ember',
  'deprecate-import-test-from-ember',
  'deprecate-import-testing-from-ember',
  'ember-modifier.function-based-options',
  // This warning is triggered a lot, and not directly fixable by us https://github.com/emberjs/ember-string/issues/370
  'ember-string.add-package',
  'importing-inject-from-ember-service',
  'warp-drive:deprecate-legacy-request-methods',
];

setupDeprecationWorkflow({
  throwOnUnhandled: false,
  workflow: [
    ...deprecationsToSilence.map((matchId) => {
      return {
        handler: 'silence' as const,
        matchId,
      };
    }),
  ],
});
